import dayjs from 'dayjs';
import { Cookies } from 'domains/common/cookies/server';
import type { ParsedObject } from 'domains/common/queryParser';
import { QueryParser } from 'domains/common/queryParser';
import type { GetServerSidePropsContext } from 'next';

import type { AppStore } from 'redux-store';

import { PaymentsPageServerAbstract } from '../../common/server/payments-page.server.abstract';
import type { ProductsService } from '../../products/products.service';
import { actions } from './payments.reducer';

const limitStartCookieName = 'limitStart';

export class PaymentsService extends PaymentsPageServerAbstract {
  constructor(private readonly productsService: ProductsService) {
    super();
  }

  screen = 'special-offer';

  setLimit({
    context,
    store,
  }: {
    context: GetServerSidePropsContext;
    store: AppStore;
  }): void {
    const query = new QueryParser(context.query as ParsedObject);
    const isLimitQuery = query.has('limit');
    const limitQueryCookie = context.req.cookies[limitStartCookieName] as
      | string
      | undefined;

    if (!isLimitQuery && !limitQueryCookie) {
      return;
    }

    let limitStart = limitQueryCookie || new Date().toISOString();

    if (limitQueryCookie) {
      const diff = dayjs().diff(limitQueryCookie);
      const duration = dayjs.duration(diff);

      if (duration.days() !== 0) {
        limitStart = new Date().toISOString();
      }
    }

    const cookies = new Cookies(context);
    cookies
      .add(limitStartCookieName, limitStart, { maxAge: 60 * 60 * 24 })
      .save();

    store.dispatch(actions.showTimer({ start: limitStart }));
  }

  async server({
    context,
    store,
  }: {
    context: GetServerSidePropsContext;
    store: AppStore;
  }): Promise<void> {
    await Promise.allSettled([
      this.setLimit({ context, store }),
      super.server({
        context,
        store,
      }),
      this.isAuthenticated({ context })
        ? this.loadProfile({ store, context })
        : null,
      this.isAuthenticated({ context })
        ? this.productsService.getPurchasesThunk({ store }, context)
        : null,
    ]);
  }
}
